import React, { useContext, useEffect, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const EmployeeContext = React.createContext();


export const EmployeeProvider = ({ children }) => {

    const { btoken, stoken } = useUserContext();

    let data = { btoken, stoken };

    const {
        loading: staffLoading, data: allStaffs, fetchData: getStaffData
    } = useFetch('/getStaffs', data);



    const [showAddStaff, setShowAddStaff] = useState(false);
    const CloseAddStaff = () => setShowAddStaff(false);
    const openAddStaff = () => setShowAddStaff(true);

    const [showEditStaff, setShowEditStaff] = useState(false);
    const CloseEditStaff = () => setShowEditStaff(false);
    const openEditStaff = () => setShowEditStaff(true);

    return (
        <EmployeeContext.Provider value={{

            showAddStaff, CloseAddStaff, openAddStaff,
            showEditStaff, CloseEditStaff, openEditStaff,

            staffLoading, allStaffs, getStaffData,
        }}>
            {children}
        </EmployeeContext.Provider>
    );
};

// make sure use
export const useEmployeeContext = () => {
    return useContext(EmployeeContext);
};
